import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { toast } from 'sonner';
import API_URL from '@/config/api';

/** Manual "Number of spaces left" with up/down arrows — not linked to bookings. */
export function SpacesLeftStepper({ course, onSaved }) {
  const [n, setN] = useState(course.spaces_left ?? 0);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setN(course.spaces_left ?? 0); }, [course.spaces_left]);

  const save = async (next) => {
    const value = Math.max(0, Math.min(999, next));
    setN(value); setBusy(true);
    try {
      const res = await fetch(`${API_URL}/api/staff/training-courses/${course.id}`, {
        method: 'PUT', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ spaces_left: value }),
      });
      if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || 'Could not save');
      onSaved?.();
    } catch (e) { toast.error(e.message); setN(course.spaces_left ?? 0); } finally { setBusy(false); }
  };
  const stop = (e) => e.stopPropagation();

  return (
    <div className="mt-2 inline-flex items-center gap-2" onClick={stop} onKeyDown={stop} data-testid={`spaces-left-${course.id}`}>
      <span className="text-xs font-semibold text-gray-700">Number of spaces left</span>
      <div className="inline-flex items-center rounded-lg border border-gray-300 bg-white overflow-hidden">
        <span className={`w-10 text-center text-base font-extrabold tabular-nums ${n === 0 ? 'text-rose-700' : 'text-gray-900'}`} data-testid={`spaces-left-value-${course.id}`}>{n}</span>
        <div className="flex flex-col border-l border-gray-300">
          <button type="button" onClick={() => save(n + 1)} disabled={busy} aria-label="Increase spaces left" className="h-5 w-7 inline-flex items-center justify-center hover:bg-gray-100 disabled:opacity-50" data-testid={`spaces-left-up-${course.id}`}><ChevronUp className="w-3.5 h-3.5" /></button>
          <button type="button" onClick={() => save(n - 1)} disabled={busy || n === 0} aria-label="Decrease spaces left" className="h-5 w-7 inline-flex items-center justify-center border-t border-gray-300 hover:bg-gray-100 disabled:opacity-50" data-testid={`spaces-left-down-${course.id}`}><ChevronDown className="w-3.5 h-3.5" /></button>
        </div>
      </div>
    </div>
  );
}
